import { useCallback, useEffect, useState } from 'react';
import { Table } from "react-bootstrap";
import { games } from '../../../constants/games';
import { blue, green, prizeDraws, red } from '../../../constants/prize-draws';
import usePegaMas from '../../../hooks/useJogos';
import Ball from "../../shared/Ball/Ball";
import "./styles.css";

const ResultsTable = () => {
  const orderedColors = [blue, blue, red, red, green];
  const resultPerPage: number = 5;
  const [error, setError] = useState<string | null>(null);
  const { data = {}, getResults } = usePegaMas();
  const lotteryResults = data.lotteryResults || [];
  const { getPrizes, data: prizes, succeed } = usePegaMas();
  
  useEffect(() => {
    fetchResults();
    getPrizes(games.PEGAMAS).catch(() => setError('Hubo un problema al obtener los premios.'));
  }, []);

  const fetchResults = useCallback(() => {
    setError(null);
    getResults(games.PEGAMAS, resultPerPage).catch(() => setError('Hubo un problema al obtener los resultados.'));
  }, []);

  const resultsData = lotteryResults.map((item: any) => {
    const numbers = item.result.split("-").map((num: string) => num.padStart(2, '0'));
    const balls = numbers.map((number: number, i: number) => ({
      show: true,
      color: orderedColors[i] || green,
      number: number,
    }));

    return {
      id: item.code,
      time: item.time,
      balls: balls,
    };
  });


  // const ballPrizes = prizeDraws.map((result, index) => ({
  //   ...result,
  //   id: `prize-${index}`,
  //   prize: succeed && prizes[index] || "",
  // }));

  const renderBalls = (balls: any) => {
    return balls.map((ball: any, index: any) => {
      if (ball.show) {
        return <Ball key={index} color={ball.color} number={ball.number} />;
      } else {
        return <div key={index} style={{ width: "40px" }}>&nbsp;</div>;
      }
    });
  };

  // const renderPrizeRowBalls = (balls: any[], groupBreaks: number[]) => {
  //   const result: JSX.Element[] = [];

  //   balls.forEach((ball, index) => {
  //     if (ball.show) {
  //       result.push(
  //         <Ball key={`ball-${index}`} color={ball.color} number={ball.number} width="4.6vw" height="4.6vw"/>
  //       );
  //     }

  //     if (ball.separatorAfter) {
  //       result.push(
  //         <span key={`sep-${index}`} className="separator">
  //           {ball.separatorAfter}
  //         </span>
  //       );
  //     }

  //     if (groupBreaks.includes(index)) {
  //       result.push(
  //         <span key={`plus-${index}`} className="separator">+</span>
  //       );
  //     }
  //   });

  //   return result;
  // };

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div>
      <Table className="text-center results-table spaced-rows-table">
        <thead>
          <tr>
            <th className="bg-transparent text-white fw-600 h1">SORTEO</th>
            <th className="bg-transparent text-white fw-600 h1">HORA</th>
            <th className="bg-transparent text-white fw-600 h1">RESULTADOS</th>
          </tr>
        </thead>
        <tbody>
          {resultsData.map((result: any, index: number) => (
            <tr key={index}>
              <td className="bg-red text-white fw-bold py-2 h1">{result.id}</td>
              <td className="bg-red text-white fw-bold py-2 h1">{result.time}</td>
              <td className="bg-red text-white fw-bold py-2">
                <div className="balls-container">{renderBalls(result.balls)}</div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ResultsTable;